var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { resolveItemTypeMultilingualUrl } from '../../utils/resolve-item-type-multilingual-url';
import { ITEM_TYPES } from '../../types/ItemTypes';
import { buildOgImagePreviewUrl } from '../../utils/build-og-image-preview';
import { SD_STATUS } from '../../consts/consts';
import { RATE_TYPES } from './constants';
import { getServiceMediaItems, getStructuredData } from './adapter-utils';
// until booking service will provide us all required data
export var requiredSchemaVariables = function () { return []; };
export var getSdStatus = function () {
    // until booking service will provide us all required data
    return SD_STATUS.DISABLED_DUE_TO_MISSING_INFO;
};
export var getData = function (IDs, itemData) {
    var _a, _b;
    var _c, _d, _e, _f;
    var service = itemData.service;
    var imageData = ((_d = (_c = service === null || service === void 0 ? void 0 : service.media) === null || _c === void 0 ? void 0 : _c.mainMedia) === null || _d === void 0 ? void 0 : _d.image) || {};
    var _g = getPaymentData(service), price = _g.price, currency = _g.currency;
    var mediaItems = getServiceMediaItems(service) || [];
    var data = __assign((_a = {}, _a[IDs.PAGE_URL] = resolveItemTypeMultilingualUrl(ITEM_TYPES.BOOKINGS_SERVICE, itemData, (_f = (_e = service === null || service === void 0 ? void 0 : service.urls) === null || _e === void 0 ? void 0 : _e.servicePage) === null || _f === void 0 ? void 0 : _f.url), _a[IDs.TITLE] = (service === null || service === void 0 ? void 0 : service.name) || '', _a[IDs.DESCRIPTION] = (service === null || service === void 0 ? void 0 : service.description) || '', _a[IDs.SESSION_TYPE] = (service === null || service === void 0 ? void 0 : service.type) || '', _a[IDs.PRICE_AMOUNT] = price, _a[IDs.CURRENCY] = currency, _a[IDs.MAIN_IMAGE] = buildOgImagePreviewUrl(imageData) || '', _a[IDs.IMAGE_HEIGHT] = imageData.height || '', _a[IDs.IMAGE_WIDTH] = imageData.width || '', _a[IDs.IMAGE_ALT] = imageData.altText || '', _a[IDs.ID] = (service === null || service === void 0 ? void 0 : service.id) || '', _a[IDs.STATUS] = (service === null || service === void 0 ? void 0 : service.status) || '', _a[IDs.MEDIA_ITEMS] = mediaItems, _a), getStructuredData(IDs, itemData, mediaItems));
    var sdStatus = getSdStatus() !== SD_STATUS.ENABLED;
    return __assign(__assign({}, data), (_b = {}, _b[IDs.SD_DISABLE_SCHEMA] = sdStatus, _b));
};
var getPaymentData = function (service) {
    var _a, _b, _c, _d, _e, _f, _g;
    var rateType = (_b = (_a = service === null || service === void 0 ? void 0 : service.payment) === null || _a === void 0 ? void 0 : _a.rateType) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    var paymentData = ((_c = service === null || service === void 0 ? void 0 : service.payment) === null || _c === void 0 ? void 0 : _c[rateType]) || {};
    if (rateType === RATE_TYPES.FIXED) {
        return {
            price: (_d = paymentData.price) === null || _d === void 0 ? void 0 : _d.value,
            currency: (_e = paymentData.price) === null || _e === void 0 ? void 0 : _e.currency,
        };
    }
    if (rateType === RATE_TYPES.VARIED) {
        return {
            price: (_f = paymentData.defaultPrice) === null || _f === void 0 ? void 0 : _f.value,
            currency: (_g = paymentData.defaultPrice) === null || _g === void 0 ? void 0 : _g.currency,
        };
    }
    return {
        price: '',
        currency: '',
    };
};
export var getSlug = function (item) { var _a, _b; return (_b = (_a = item === null || item === void 0 ? void 0 : item.service) === null || _a === void 0 ? void 0 : _a.mainSlug) === null || _b === void 0 ? void 0 : _b.name; };
export var getFullUrl = function (item) { var _a, _b, _c; return (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.service) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.servicePage) === null || _c === void 0 ? void 0 : _c.url; };
export var setFullUrl = function (item, url) {
    if (url === void 0) { url = ''; }
    var updatedItem = JSON.parse(JSON.stringify(item));
    updatedItem.service.urls.servicePage.url = url;
    return updatedItem;
};
export var updateItemDataWithSlug = function (itemData, slugValue) {
    var updatedItemData = JSON.parse(JSON.stringify(itemData));
    var oldSlug = getSlug(itemData);
    if (oldSlug !== '') {
        updatedItemData.service.mainSlug.name = slugValue;
    }
    return updatedItemData;
};
